export const apidata = [
  {
    _id: {
      $oid: "678d28d664348d2a78e5a482"
    },
    origin: "Representment",
    parent: "rp",
    path: "rp.Id",
    label: "Representment Id",
    type: "number",
    hiddenType: "number",
    placeholder: "representmentid",
    useInContent: true,
    needsReview: false,
    __v: 0,
    defid: "634edbacf0b07d199822a766"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a483"
    },
    origin: "Representment",
    parent: "rp",
    path: "rp.ReasonCode",
    useInContent: true,
    label: "Reason Code (Number)",
    description: "Numeric indicator for why the transaction is being disputed.",
    type: "string",
    hiddenType: "number",
    placeholder: "reasoncodenumber",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed54"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a484"
    },
    origin: "Representment",
    parent: "rp",
    path: "rp.ReasonCodeDescription",
    label: "Reason Description",
    useInContent: true,
    description: "More details on why the transaction is being disputed.",
    type: "string",
    hiddenType: "string",
    placeholder: "reasondescrip",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed59"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a485"
    },
    origin: "Representment",
    parent: "rp",
    path: "rp.ReasonCodeCagtegory",
    label: "Reason Code Category",
    useInContent: true,
    description: "Indicates the reason why the transaction is being disputed.",
    type: "string",
    hiddenType: "string",
    placeholder: "rc",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed57"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a486"
    },
    origin: "Representment",
    parent: "rp",
    path: "rp.ReasonCodeAllowedDaysToDispute",
    label: "Reason Code Allowed Days To Dispute",
    useInContent: true,
    description: "Indicates the how many days are allowed for the dispute.",
    type: "number",
    hiddenType: "number",
    placeholder: "daystofilecb",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed73"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a487"
    },
    origin: "Representment",
    parent: "rp",
    path: "rp.DisputeDate",
    label: "DisputeDate",
    useInContent: true,
    type: "string",
    hiddenType: "date",
    placeholder: "RpDspDt",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a488"
    },
    origin: "Representment",
    parent: "rp",
    path: "rp.DisputeAmount",
    label: "Dispute Amount",
    useInContent: true,
    description: "The amount being disputed by the customer.",
    type: "number",
    hiddenType: "number",
    placeholder: "disputeamt",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed45"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a489"
    },
    origin: "Representment",
    parent: "rp",
    path: "rp.ChargebackArrivedTooLate",
    label: "Chargeback Too Late",
    useInContent: true,
    description: "Indicates whether the chargeback request was filed too late.",
    type: "boolean",
    hiddenType: "boolean",
    placeholder: "cbtoolate",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed31"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a48a"
    },
    origin: "Representment",
    parent: "rp",
    path: "rp.Chargeback",
    label: "Chargeback",
    useInContent: true,
    type: "object",
    hiddenType: "object",
    placeholder: "RpCB",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a48b"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ChargebackId",
    label: "Chargeback Id",
    useInContent: true,
    type: "number",
    hiddenType: "number",
    placeholder: "cbid",
    needsReview: false,
    __v: 0,
    defid: "634efb36f0b07d199822a7e6"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a48c"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.MerchantAccountName",
    label: "Merchant Account Name",
    useInContent: true,
    description: "Name of the associated merchant",
    type: "string",
    hiddenType: "date",
    placeholder: "merchantaccountname",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed78"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a48d"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.Amount",
    label: "Chargeback Amount",
    useInContent: true,
    description: "The amount charged back to the customer.",
    type: "number",
    hiddenType: "number",
    placeholder: "cbamount",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed2d"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a48e"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ReferenceTransactionAmount",
    label: "Reference Transaction Amount",
    useInContent: true,
    type: "number",
    hiddenType: "number",
    placeholder: "reftxnamt",
    needsReview: false,
    __v: 0,
    defid: "634efd80f0b07d199822a81a"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a48f"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ConsumerName",
    label: "Consumer Name",
    useInContent: true,
    type: "string",
    hiddenType: "string",
    placeholder: "consumername",
    needsReview: false,
    __v: 0,
    defid: "634efe7af0b07d199822a82f"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a490"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.TransactionDate",
    label: "Dispute Date",
    useInContent: true,
    description: "The date the chargeback dispute was filed by the customer.",
    type: "string",
    hiddenType: "date",
    placeholder: "disputedate",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed44"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a491"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.DisputeDate",
    label: "Chargeback Date",
    useInContent: true,
    description: "The date of the chargeback.",
    type: "string",
    hiddenType: "date",
    placeholder: "cbdate",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed36"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a492"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.Currency",
    label: "Currency",
    useInContent: true,
    type: "string",
    hiddenType: "string",
    placeholder: "currency",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed79"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a493"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ExternalChargebackId",
    label: "ExternalChargebackId",
    useInContent: true,
    type: "string",
    hiddenType: "number",
    placeholder: "RpCBExtCBId",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a494"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.BIN",
    label: "BIN",
    useInContent: true,
    description: "BIN  number from chargeback.",
    type: "string",
    hiddenType: "number",
    placeholder: "bin",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed77"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a495"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.LastFour",
    useInContent: true,
    description: "Last four digits of the credit card used.",
    type: "string",
    hiddenType: "number",
    placeholder: "lastfour",
    needsReview: false,
    __v: 0,
    label: "Last Four of CC",
    defid: "62980feeab36c31cc0a9ed3f"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a496"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.AccountNumber",
    label: "CB AccountNumber",
    useInContent: true,
    type: "string",
    hiddenType: "string",
    placeholder: "RpCBAcnNum",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a497"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.Descriptor",
    label: "Descriptor",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBDes",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a498"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.DescriptorContact",
    label: "DescriptorContact",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBDesCon",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a499"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ChargebackType",
    label: "ChargebackType",
    useInContent: true,
    type: "string",
    hiddenType: "number",
    placeholder: "RpCBCBTyp",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a49a"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ChargebackLastAction",
    label: "ChargebackLastAction",
    useInContent: true,
    type: "string",
    hiddenType: "number",
    placeholder: "RpCBCBLasAct",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a49b"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ChargebackCycle",
    label: "ChargebackCycle",
    useInContent: true,
    type: "string",
    hiddenType: "number",
    placeholder: "RpCBCBCyc",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a49c"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.CycleState",
    label: "CycleState",
    useInContent: false,
    type: "string",
    hiddenType: "string",
    placeholder: "RpCBCycSta",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a49d"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.CycleStateCategory",
    label: "CycleStateCategory",
    useInContent: false,
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBCycStaCat",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a49e"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.SourceCycleState",
    label: "SourceCycleState",
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBSrcCycSta",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a49f"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.CycleStateCode",
    label: "CycleStateCode",
    useInContent: false,
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBCycStaCod",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4a0"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.TransactionType",
    label: "TransactionType",
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBTrxTyp",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4a1"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.PaymentType",
    label: "PaymentType",
    useInContent: true,
    type: "string",
    hiddenType: "string",
    placeholder: "RpCBPayTyp",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4a2"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ExpirationDate",
    label: "ExpirationDate",
    useInContent: true,
    type: "string",
    hiddenType: "number",
    placeholder: "RpCBExpDt",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4a3"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.AuthorizationCode",
    label: "Authorization Code",
    useInContent: true,
    description: "Auth Code for the chargeback.",
    type: "string",
    hiddenType: "number",
    placeholder: "authcode",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed1f"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4a4"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.OrderId",
    label: "OrderId",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBOrId",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4a5"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ExternalOrderId",
    label: "ExternalOrderId",
    useInContent: true,
    type: "string",
    hiddenType: "string",
    placeholder: "RpCBExtOrId",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4a6"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ARN",
    useInContent: "true",
    label: "ARN",
    description: "ARN for the chargeback.",
    type: "string",
    hiddenType: "number",
    placeholder: "arn",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed24"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4a7"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.FirstName",
    label: "First Name",
    useInContent: true,
    type: "string",
    hiddenType: "string",
    placeholder: "firstname",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed7a"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4a8"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.LastName",
    useInContent: false,
    label: "LastName (CB)",
    type: "string",
    hiddenType: "string",
    placeholder: "RpCBLasNm",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4a9"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.CRMUserName",
    label: "CRM Username",
    useInContent: false,
    type: "null",
    hiddenType: "null",
    placeholder: "crm_username",
    needsReview: true,
    __v: 0,
    defid: "6640ce95696378bb7a5387cc"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4aa"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.CRMPassword",
    label: "CRMPassword",
    useInContent: false,
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBPas",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4ab"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.CRMSearchUrl",
    label: "CRMSearchUrl",
    useInContent: false,
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBSeaUrl",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4ac"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.CurrentCycle",
    label: "CurrentCycle",
    useInContent: false,
    type: "string",
    hiddenType: "string",
    placeholder: "RpCBCrtCyc",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4ad"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ChargebackState",
    label: "ChargebackState",
    useInContent: false,
    type: "string",
    hiddenType: "string",
    placeholder: "RpCBCBSta",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4ae"
    },
    origin: "Representment",
    path: "rp.Chargeback.CanBeActedOn",
    label: "CanBeActedOn",
    useInContent: false,
    type: "boolean",
    hiddenType: "boolean",
    placeholder: "RpCBCanBeActOn",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4af"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.StatusIsPreArbLost",
    label: "StatusIsPreArbLost",
    useInContent: false,
    type: "boolean",
    hiddenType: "boolean",
    placeholder: "RpCBStaIsPreArbLos",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4b0"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.CardBrandImage",
    label: "CardBrandImage",
    useInContent: true,
    type: "string",
    hiddenType: "string",
    placeholder: "RpCBCarBraIma",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4b1"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.CardBrand",
    label: "Card Brand",
    useInContent: true,
    description: "Returns the brand of credit card used (Visa, Mastercard, etc)",
    type: "string",
    hiddenType: "string",
    placeholder: "cardbrand",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed30"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4b2"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.Issuer",
    label: "Issuer",
    useInContent: true,
    type: "string",
    hiddenType: "string",
    placeholder: "RpCBIss",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4b3"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.CardTypeFromBIN",
    label: "CardTypeFromBIN",
    useInContent: false,
    type: "string",
    hiddenType: "string",
    placeholder: "RpCBCarTypFro",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4b4"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.Category",
    label: "CB Category",
    useInContent: false,
    type: "string",
    hiddenType: "string",
    placeholder: "RpCBCat",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4b5"
    },
    origin: "Representment",
    path: "rp.Chargeback.Country",
    label: "Country",
    useInContent: false,
    type: "string",
    hiddenType: "string",
    placeholder: "RpCBCou",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4b6"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.CountryISO",
    label: "Country ISO",
    useInContent: false,
    description: "Indicates the country where the transaction originated from.",
    type: "string",
    hiddenType: "string",
    placeholder: "country",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed3a"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4b7"
    },
    origin: "Representment",
    path: "rp.Chargeback.ReasonCode",
    label: "Reason Code",
    useInContent: false,
    type: "string",
    hiddenType: "number",
    placeholder: "reasoncode",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed7b"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4b8"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ReasonCodeDescription",
    label: "ReasonCodeDescription (CB)",
    useInContent: false,
    type: "string",
    hiddenType: "number",
    placeholder: "RpCBReaCodDesc",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4b9"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.CBCategory",
    label: "Category (CB)",
    useInContent: false,
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBCat",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4ba"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.Action_Id",
    label: "Action_Id",
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBActId",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4bb"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ActionChoices",
    label: "ActionChoices",
    useInContent: false,
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBActCho",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4bc"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.FoughtNotFoughtReason_Id",
    label: "FoughtNotFoughtReason_Id",
    useInContent: false,
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBFouNotFouReaId",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4bd"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.FoughtNotFought",
    label: "Chargeback Accepted",
    useInContent: false,
    description: "Indicates if the chargeback was accepted or not.",
    type: "string",
    hiddenType: "string",
    placeholder: "cbaccepted",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed39"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4be"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ChargebackSource",
    label: "ChargebackSource",
    useInContent: false,
    type: "string",
    hiddenType: "string",
    placeholder: "RpCBCBSrc",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4bf"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.Deadline",
    label: "Deadline (CB)",
    useInContent: true,
    type: "string",
    hiddenType: "date",
    placeholder: "RpCBDea",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4c0"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ReceivedDate",
    label: "Date Received",
    useInContent: true,
    type: "string",
    hiddenType: "date",
    placeholder: "datereceived",
    needsReview: false,
    __v: 0,
    defid: "67bcf134ee18ea235fdff8c4"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4c1"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.AgeHours",
    label: "Age Hours",
    useInContent: true,
    description: "Hours since the chargeback.",
    type: "number",
    hiddenType: "number",
    placeholder: "agehours",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed1b"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4c2"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.TimeBetweenTransactionAndDispute",
    label: "Hours Between Transaction and Dispute",
    useInContent: true,
    description: "Hours elapsed between trx and dispute.",
    type: "number",
    hiddenType: "number",
    placeholder: "hoursbetweentrxanddispute",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed71"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4c3"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.AgeDays",
    label: "Age Days",
    useInContent: true,
    description: "Days since the chargeback.",
    type: "number",
    hiddenType: "number",
    placeholder: "agedays",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed1e"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4c4"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.DaysBetweenTransactionAndDispute",
    label: "Days Between Transaction and Dispute",
    useInContent: true,
    description: "Days elapsed between trx and dispute.",
    type: "number",
    hiddenType: "number",
    placeholder: "daysbetweentrxanddispute",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed40"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4c5"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.Notes",
    label: "Notes (CB)",
    useInContent: false,
    type: "string",
    hiddenType: "number",
    placeholder: "RpCBNot",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4c6"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.Files",
    label: "Files (CB)",
    useInContent: false,
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBFil",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4c7"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ChargebackActions",
    label: "ChargebackActions",
    useInContent: false,
    description: "This is an array in the api, but what goes in here?",
    type: "array",
    hiddenType: "array",
    placeholder: "RpCBCBAct",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4c8"
    },
    origin: "Representment",
    path: "rp.Chargeback.ChargebackCycles",
    label: "ChargebackCycles",
    useInContent: false,
    type: "array",
    hiddenType: "array",
    placeholder: "RpCBCBCyc",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4c9"
    },
    origin: "Representment",
    parent: "rp.Chargeback.ChargebackCycles",
    path: "rp.Chargeback.ChargebackCycles{Object}",
    label: "{Object}",
    useInContent: false,
    description: "There can be multiple instances of this object inside of ChargebackCycles",
    type: "object",
    hiddenType: "object",
    placeholder: "RpCB",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4ca"
    },
    origin: "Representment",
    parent: "rp.Chargeback.ChargebackCycles{Object}",
    path: "rp.Chargeback.ChargebackCycles{Object}.Date",
    label: "Date",
    useInContent: false,
    type: "string",
    hiddenType: "date",
    placeholder: "RpCBDt",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4cb"
    },
    origin: "Representment",
    parent: "rp.Chargeback.ChargebackCycles{Object}",
    path: "rp.Chargeback.ChargebackCycles{Object}.Other",
    label: "Other",
    useInContent: false,
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBOth",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4cc"
    },
    origin: "Representment",
    parent: "rp.Chargeback.ChargebackCycles{Object}",
    path: "rp.Chargeback.ChargebackCycles{Object}.ActionBy",
    label: "ActionBy",
    useInContent: false,
    type: "string",
    hiddenType: "string",
    placeholder: "RpCBActBy",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4cd"
    },
    origin: "Representment",
    parent: "rp.Chargeback.ChargebackCycles{Object}",
    path: "rp.Chargeback.ChargebackCycles{Object}.Cycle",
    label: "Cycle",
    useInContent: false,
    type: "string",
    hiddenType: "string",
    placeholder: "RpCBCyc",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4ce"
    },
    origin: "Representment",
    parent: "rp.Chargeback.ChargebackCycles{Object}",
    path: "rp.Chargeback.ChargebackCycles{Object}.CycleState",
    label: "CycleState",
    useInContent: false,
    type: "string",
    hiddenType: "string",
    placeholder: "RpCBCycSta",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4cf"
    },
    origin: "Representment",
    parent: "rp.Chargeback.ChargebackCycles{Object}",
    path: "rp.Chargeback.ChargebackCycles{Object}.CycleStateCode",
    useInContent: false,
    label: "CycleStateCode",
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBCycStaCod",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4d0"
    },
    origin: "Representment",
    parent: "rp.Chargeback.ChargebackCycles{Object}",
    path: "rp.Chargeback.ChargebackCycles{Object}.CycleStateCategory",
    label: "CycleStateCategory",
    useInContent: false,
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBCycStaCat",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4d1"
    },
    origin: "Representment",
    parent: "rp.Chargeback.ChargebackCycles{Object}",
    path: "rp.Chargeback.ChargebackCycles{Object}.SourceCycleState",
    label: "SourceCycleState",
    useInContent: false,
    type: "string",
    hiddenType: "string",
    placeholder: "RpCBSrcCycSta",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4d2"
    },
    origin: "Representment",
    parent: "rp.Chargeback.ChargebackCycles{Object}",
    path: "rp.Chargeback.ChargebackCycles{Object}.Amount",
    label: "Amount",
    useInContent: false,
    type: "number",
    hiddenType: "number",
    placeholder: "RpCBAmt",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4d3"
    },
    origin: "Representment",
    parent: "rp",
    path: "rp.Documents",
    label: "Documents",
    useInContent: false,
    description: "This is null in the api, but should it be an array? If so, of what?",
    type: "null",
    hiddenType: "null",
    placeholder: "Documents",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4d4"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ExternalTransactionId",
    label: "ExternalTransactionId (CB)",
    useInContent: true,
    type: "string",
    hiddenType: "number",
    placeholder: "RpCBExtTrxId",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4d5"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.TransactionId",
    label: "TransactionId",
    type: "number",
    hiddenType: "number",
    placeholder: "RpCBTrxId",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4d6"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.PriorRefund",
    label: "Prior Refund",
    type: "null",
    hiddenType: "null",
    placeholder: "priorrefund",
    needsReview: true,
    __v: 0,
    defid: "63bc5c763f0f1d2c3449f887"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4d7"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.PriorAlert",
    label: "PriorAlert",
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBPriAle",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4d8"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.PriorRDR",
    label: "PriorRDR",
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBPri",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4d9"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ProcessorCaseId",
    label: "Processor Case Id",
    useInContent: true,
    type: "string",
    hiddenType: "number",
    placeholder: "procaseid",
    needsReview: false,
    __v: 0,
    defid: "65de6c0ba2846c9f3539545c"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4da"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ProcessorMerchantId",
    label: "ProcessorMerchantId",
    useInContent: true,
    type: "string",
    hiddenType: "number",
    placeholder: "RpCBPrcMerId",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4db"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ProcessorDBA",
    label: "ProcessorDBA",
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBPrc",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4dc"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ReplyByDate",
    label: "ReplyByDate",
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBRepByDt",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4dd"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ExtraManageChoice",
    label: "ExtraManageChoice",
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBExtMngChc",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4de"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.ExtraManageChoice2",
    label: "ExtraManageChoice2",
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBExtMngChc",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4df"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.UserDefinedChoice",
    label: "UserDefinedChoice",
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBUsrDefChc",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4e0"
    },
    origin: "Representment",
    parent: "rp.Chargeback",
    path: "rp.Chargeback.UserDefinedChoice2",
    label: "UserDefinedChoice2",
    type: "null",
    hiddenType: "null",
    placeholder: "RpCBUsrDefChc",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4e1"
    },
    origin: "Representment",
    parent: "rp",
    path: "rp.RepresentmentTransactionInfo",
    label: "RepresentmentTransactionInfo",
    description: "This is an object containing many data elements inside it",
    type: "object",
    hiddenType: "object",
    placeholder: "RpRepTrxIn",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4e2"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.Amount",
    label: "Transaction Amount",
    description: "Returns the amount of the transaction.",
    type: "number",
    hiddenType: "number",
    placeholder: "trxamount",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed6d"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4e3"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.CardBrand",
    label: "CardBrand",
    type: "string",
    hiddenType: "string",
    placeholder: "RpRepTrxInCarBra",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4e4"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.CardNumber",
    label: "CardNumber",
    type: "string",
    hiddenType: "string",
    placeholder: "RpRepTrxInCarNum",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4e5"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.ExpDate",
    label: "ExpDate",
    type: "string",
    hiddenType: "number",
    placeholder: "RpRepTrxInExpDt",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4e6"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.Cycle",
    label: "Cycle",
    type: "null",
    hiddenType: "null",
    placeholder: "RpRepTrxInCyc",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4e7"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.TransactionDate",
    label: "Transaction Date",
    description: "Returns the date of the transaction.",
    type: "string",
    hiddenType: "date",
    useInContent: true,
    placeholder: "trxdate",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed6c"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4e8"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.AuthCode",
    label: "AuthCode",
    type: "string",
    hiddenType: "number",
    placeholder: "RpRepTrxInAutCod",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4e9"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.CancelStatus_Id",
    label: "CancelStatus_Id",
    type: "null",
    hiddenType: "null",
    placeholder: "RpRepTrxInCanStaId",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4ea"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.Cancelled",
    label: "Cancelled",
    type: "null",
    hiddenType: "null",
    placeholder: "cancelled",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed32"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4eb"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.CancelDate",
    label: "Cancel Date",
    type: "null",
    hiddenType: "null",
    placeholder: "canceldate",
    useInContent: true,
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed2a"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4ec"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.CancelReason",
    label: "Transaction Cancelled Reason",
    type: "null",
    hiddenType: "null",
    placeholder: "cancelledreason",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed6a"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4ed"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.WasCustomerServiceContacted",
    label: "Was Customer Service Contacted",
    type: "null",
    hiddenType: "null",
    placeholder: "wascscontacted",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed6f"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4ee"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.LastCustomerServiceContactDate",
    label: "Last CS Contact Date",
    type: "null",
    hiddenType: "null",
    placeholder: "CScontactdate",
    useInContent: true,
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed7c"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4ef"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.LastCustomerServiceContactReason",
    label: "LastCustomerServiceContactReason",
    type: "null",
    hiddenType: "null",
    placeholder: "RpRepTrxInLasCusSerConRea",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4f0"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.DeviceId",
    label: "Device Id",
    type: "null",
    hiddenType: "null",
    placeholder: "device_id",
    needsReview: true,
    __v: 0,
    defid: "6640cd7f696378bb7a5387bd"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4f1"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.GeoId",
    label: "Geo ID",
    type: "null",
    hiddenType: "null",
    placeholder: "geoid",
    needsReview: true,
    __v: 0,
    defid: "67cf3966c150c295b18a6879"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4f2"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.OTP_SMS",
    label: "OTP_SMS",
    type: "null",
    hiddenType: "null",
    placeholder: "RpRepTrxIn",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4f3"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.TransactionAmount",
    label: "TransactionAmount",
    useInContent: true,
    type: "number",
    hiddenType: "number",
    placeholder: "RpRepTrxInTrxAmt",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4f4"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.AVSMatchCode_Id",
    label: "AVSMatchCode_Id",
    useInContent: true,
    description: "Returns the AVS Match Code for a given order.",
    type: "number",
    hiddenType: "number",
    placeholder: "RpRepTrxInMatCodId",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4f5"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.TransactionAVSCode",
    label: "TransactionAVSCode",
    useInContent: true,
    type: "string",
    hiddenType: "string",
    placeholder: "RpRepTrxInTrxCod",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4f6"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.AVSCode",
    label: "AVS Match Code",
    useInContent: true,
    type: "string",
    hiddenType: "string",
    placeholder: "avscode",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed20"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4f7"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.AVSCodeDescription",
    label: "AVS Code Description",
    useInContent: true,
    type: "string",
    hiddenType: "string",
    placeholder: "avscodedescription",
    needsReview: false,
    __v: 0,
    defid: "66609e1e741bfd9df636cb63"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4f8"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.CVSMatchCode_Id",
    label: "CVV Code",
    useInContent: true,
    description: "The CVS or CVV code associated with the order.",
    type: "number",
    hiddenType: "number",
    placeholder: "cvv",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed38"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4f9"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.ThreeDSecure_Id",
    label: "ThreeD (3ds) Secure ID",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "3ds",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed7d"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4fa"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.ExternalTransactionId",
    label: "ExternalTransactionId",
    useInContent: true,
    type: "string",
    hiddenType: "number",
    placeholder: "RpRepTrxInExtTrxId",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4fb"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.ExternalRefundId",
    label: "ExternalRefundId",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "RpRepTrxInExtRfndId",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4fc"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.RefundTransaction_Id",
    label: "RefundTransaction_Id",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "RpRepTrxInRfndTrxId",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4fd"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.RefundARN",
    label: "RefundARN",
    type: "null",
    hiddenType: "null",
    placeholder: "RpRepTrxInRfnd",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4fe"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.RefundAuthCode",
    label: "RefundAuthCode",
    type: "null",
    hiddenType: "null",
    placeholder: "RpRepTrxInRfndAutCod",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a4ff"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.RefundStatus_Id",
    label: "Refund Status Id",
    type: "null",
    hiddenType: "null",
    placeholder: "refundstatus_id",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed70"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a500"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.RefundAmount",
    label: "Refund Amount",
    useInContent: true,
    type: "string",
    hiddenType: "number",
    placeholder: "refundamount",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed5b"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a501"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.RefundDate",
    label: "Refund Date",
    useInContent: true,
    type: "string",
    hiddenType: "date",
    placeholder: "refunddate",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed5c"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a502"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.Issuer",
    label: "Issuer",
    useInContent: true,
    type: "string",
    hiddenType: "string",
    placeholder: "RpRepTrxInIss",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a503"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.Case_Id",
    useInContent: true,
    label: "Case_Id",
    type: "null",
    hiddenType: "null",
    placeholder: "RpRepTrxInCasId",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a504"
    },
    origin: "Representment",
    path: "rp.RepresentmentTransactionInfo.ExternalAlertId",
    label: "Alert Received",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "alertreceived",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed1c"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a505"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.AlertInfo",
    label: "AlertInfo",
    type: "null",
    hiddenType: "null",
    placeholder: "RpRepTrxInAleIn",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a506"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.AlertProvider_Id",
    label: "AlertProvider_Id",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "RpRepTrxInAleProId",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a507"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.AlertProvider",
    label: "Alert Provider",
    type: "null",
    hiddenType: "null",
    placeholder: "alertprovider",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed6e"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a508"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.AddOns",
    label: "Add-Ons Included",
    type: "null",
    hiddenType: "null",
    placeholder: "addons",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed1d"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a509"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.HasProof",
    label: "HasProof",
    type: "null",
    hiddenType: "null",
    placeholder: "RpRepTrxInHasPro",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a50a"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.ProofDate",
    useInContent: true,
    label: "ProofDate",
    type: "null",
    hiddenType: "null",
    placeholder: "RpRepTrxInProDt",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a50b"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.ProofType",
    useInContent: true,
    label: "ProofType",
    type: "null",
    hiddenType: "null",
    placeholder: "RpRepTrxInProTyp",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a50c"
    },
    origin: "Representment",
    path: "rp.RepresentmentTransactionInfo.SubscriptionCycle",
    label: "Subscription Cycle",
    type: "null",
    hiddenType: "null",
    placeholder: "subscriptioncycle",
    needsReview: true,
    __v: 0,
    defid: "67cf34f4c150c295b18a6800"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a50d"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.SubscriptionParentId",
    label: "Subscription Parent Id",
    type: "null",
    hiddenType: "null",
    placeholder: "subscriptionparentid",
    needsReview: true,
    __v: 0,
    defid: "67cf37a2c150c295b18a6847"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a50e"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.IPAddress",
    label: "IPAddress",
    useInContent: true,
    type: "string",
    hiddenType: "string",
    placeholder: "RpRepTrxInAdr",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a50f"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.CRMUserName",
    label: "CRMUserName",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "RpRepTrxInUsrNm",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a510"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.Descriptor",
    label: "Descriptor",
    type: "string",
    hiddenType: "string",
    placeholder: "RpRepTrxInDes",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a511"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.SettlementDate",
    label: "SettlementDate",
    useInContent: true,
    type: "string",
    hiddenType: "date",
    placeholder: "RpRepTrxInSetDt",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a512"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.NotRefundedAmount",
    label: "NotRefundedAmount",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "RpRepTrxInNotRefAmt",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a513"
    },
    origin: "Representment",
    parent: "rp.RepresentmentTransactionInfo",
    path: "rp.RepresentmentTransactionInfo.Notes",
    label: "Notes",
    description: "This is an array in the API, but what goes in here?",
    type: "array",
    hiddenType: "array",
    placeholder: "RpRepTrxInNot",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a514"
    },
    origin: "Representment",
    parent: "rp",
    path: "rp.OrderInfo",
    label: "OrderInfo",
    type: "object",
    hiddenType: "object",
    placeholder: "RpOrIn",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a515"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.Id",
    label: "Order Info Id",
    useInContent: true,
    type: "number",
    hiddenType: "number",
    placeholder: "RpOrInId",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a516"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.ShipToDifferent",
    label: "Ship To Different",
    type: "boolean",
    hiddenType: "boolean",
    placeholder: "ship_different",
    needsReview: false,
    __v: 0,
    defid: "6640cde8696378bb7a5387c2"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a517"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.ReturnAttemptTooLate",
    label: "Return Attempted Too Late",
    type: "null",
    hiddenType: "null",
    placeholder: "returntoolate",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed5e"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a518"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.Products",
    label: "Products",
    description: "This is an array in the API, but what goes in here?",
    type: "array",
    hiddenType: "array",
    placeholder: "RpOrInPro",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a519"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.BillingContact",
    label: "BillingContact",
    useInContent: true,
    description: "This is an object containing many data elements inside it",
    type: "object",
    hiddenType: "object",
    placeholder: "RpOrInBillCon",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a51a"
    },
    origin: "Representment",
    parent: "rp.OrderInfo.BillingContact",
    path: "rp.OrderInfo.BillingContact.Id",
    label: "Billing ID",
    useInContent: true,
    description: "Returns the billing ID associated with the order.",
    type: "number",
    hiddenType: "number",
    placeholder: "billingid",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed23"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a51b"
    },
    origin: "Representment",
    parent: "rp.OrderInfo.BillingContact",
    path: "rp.OrderInfo.BillingContact.Name",
    label: "Billing Name",
    useInContent: true,
    description: "Returns the billing name provided by the customer.",
    type: "string",
    hiddenType: "string",
    placeholder: "billingname",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed22"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a51c"
    },
    origin: "Representment",
    parent: "rp.OrderInfo.BillingContact",
    path: "rp.OrderInfo.BillingContact.Address",
    label: "Billing Address",
    useInContent: true,
    description: "Returns the billing address provided by the customer.",
    type: "string",
    hiddenType: "string",
    placeholder: "billingaddress",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed21"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a51d"
    },
    origin: "Representment",
    parent: "rp.OrderInfo.BillingContact",
    path: "rp.OrderInfo.BillingContact.City",
    label: "Billing City",
    useInContent: true,
    description: "Returns the billing city provided by the customer.",
    type: "string",
    hiddenType: "string",
    placeholder: "billingcity",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed25"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a51e"
    },
    origin: "Representment",
    parent: "rp.OrderInfo.BillingContact",
    path: "rp.OrderInfo.BillingContact.State",
    label: "Billing State",
    useInContent: true,
    description: "Returns the billing state provided by the customer.",
    type: "string",
    hiddenType: "string",
    placeholder: "billingstate",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed26"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a51f"
    },
    origin: "Representment",
    parent: "rp.OrderInfo.BillingContact",
    path: "rp.OrderInfo.BillingContact.Zip",
    label: "Billing Zip",
    useInContent: true,
    description: "Returns the billing zip provided by the customer.",
    type: "string",
    hiddenType: "number",
    placeholder: "billingzip",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed27"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a520"
    },
    origin: "Representment",
    parent: "rp.OrderInfo.BillingContact",
    path: "rp.OrderInfo.BillingContact.Country",
    label: "Country",
    type: "string",
    hiddenType: "string",
    placeholder: "RpOrInCou",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a521"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.ShippingContact",
    label: "ShippingContact",
    description: "This is an object containing many data elements inside it",
    type: "object",
    hiddenType: "object",
    placeholder: "RpOrInShpCon",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a522"
    },
    origin: "Representment",
    parent: "rp.OrderInfo.ShippingContact",
    path: "rp.OrderInfo.ShippingContact.Id",
    label: "Shipping ID",
    description: "Returns the shipping ID associated with the order.",
    type: "number",
    hiddenType: "number",
    placeholder: "shippingid",
    needsReview: false,
    __v: 0,
    useInContent: "false",
    defid: "62980feeab36c31cc0a9ed61"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a523"
    },
    origin: "Representment",
    parent: "rp.OrderInfo.ShippingContact",
    path: "rp.OrderInfo.ShippingContact.Name",
    label: "Shipping Name",
    type: "null",
    hiddenType: "null",
    placeholder: "shippingname",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed63"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a524"
    },
    origin: "Representment",
    parent: "rp.OrderInfo.ShippingContact",
    path: "rp.OrderInfo.ShippingContact.Address",
    label: "Shipping Address",
    type: "null",
    hiddenType: "null",
    placeholder: "shippingaddress",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed65"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a525"
    },
    origin: "Representment",
    parent: "rp.OrderInfo.ShippingContact",
    path: "rp.OrderInfo.ShippingContact.City",
    label: "Shipping City",
    type: "null",
    hiddenType: "null",
    placeholder: "shippingcity",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed62"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a526"
    },
    origin: "Representment",
    parent: "rp.OrderInfo.ShippingContact",
    path: "rp.OrderInfo.ShippingContact.State",
    label: "Shipping State",
    type: "null",
    hiddenType: "null",
    placeholder: "shippingstate",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed66"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a527"
    },
    origin: "Representment",
    parent: "rp.OrderInfo.ShippingContact",
    path: "rp.OrderInfo.ShippingContact.Zip",
    label: "Shipping Zip",
    type: "null",
    hiddenType: "null",
    placeholder: "shippingzip",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed64"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a528"
    },
    origin: "Representment",
    parent: "rp.OrderInfo.ShippingContact",
    path: "rp.OrderInfo.ShippingContact.Country",
    label: "Country",
    type: "null",
    hiddenType: "null",
    placeholder: "RpOrInCou",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a529"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.MerchantOrderId",
    label: "Merchant OrderId",
    useInContent: true,
    type: "string",
    hiddenType: "string",
    placeholder: "merchantorderid",
    needsReview: false,
    __v: 0,
    defid: "67cf3286c150c295b18a67aa"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a52a"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.DeliveryLocation",
    label: "DeliveryLocation",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "RpOrInDelLoc",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a52b"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.DeliveryNotes",
    label: "DeliveryNotes",
    type: "null",
    hiddenType: "null",
    placeholder: "RpOrInDelNot",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a52c"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.DateOfOrder",
    label: "DateOfOrder",
    type: "null",
    hiddenType: "null",
    placeholder: "RpOrInDtOfOr",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a52d"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.Email",
    label: "Customer Email Address",
    useInContent: true,
    description: "Email address associated with the customer order.",
    type: "string",
    hiddenType: "string",
    placeholder: "customeremail",
    needsReview: false,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed3c"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a52e"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.IPAddress",
    label: "IP Address",
    useInContent: true,
    type: "string",
    hiddenType: "string",
    placeholder: "ip_address",
    needsReview: false,
    __v: 0,
    defid: "6640ce4f696378bb7a5387c7"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a52f"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.Shipper_Id",
    label: "Shipping Company",
    type: "null",
    hiddenType: "null",
    placeholder: "shipper_id",
    needsReview: true,
    __v: 0,
    defid: "670414e5803b8a07d71c6aec"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a530"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.ShipperName",
    label: "ShipperName",
    type: "null",
    hiddenType: "null",
    placeholder: "RpOrInShiNm",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a531"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.ShippingJson",
    label: "ShippingJson",
    type: "string",
    hiddenType: "string",
    placeholder: "RpOrInShpJso",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a532"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.TrackingNumber",
    label: "Shipping Tracking Number",
    useInContent: true,
    type: "string",
    hiddenType: "string",
    placeholder: "trackingnumber",
    needsReview: false,
    __v: 0,
    defid: "67c62dfb69dd288bb527ae27"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a533"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.DateDelivered",
    label: "Date Delivered",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "datedelivered",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed3e"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a534"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.Tax",
    label: "Tax",
    type: "null",
    hiddenType: "null",
    placeholder: "RpOrInTax",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a535"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.Shipping",
    label: "Shipping",
    type: "null",
    hiddenType: "null",
    placeholder: "RpOrInShp",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a536"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.DateShipped",
    label: "Date Shipped",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "dateshipped",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed3d"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a537"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.CarRentalDate",
    label: "Car Rental Date",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "carrentaldate",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed2e"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a538"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.CarReturnDate",
    label: "Car Return Date",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "carreturndate",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed2b"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a539"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.FlightDate",
    label: "Flight Date",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "flightdate",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed43"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a53a"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.CheckInDate",
    useInContent: true,
    label: "CheckInDate",
    type: "null",
    hiddenType: "null",
    placeholder: "RpOrInCheInDt",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a53b"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.CheckOutDate",
    label: "CheckOutDate",
    type: "null",
    hiddenType: "null",
    placeholder: "RpOrInCheOutDt",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a53c"
    },
    origin: "Representment",
    path: "rp.OrderInfo.AncillaryCharges",
    label: "AncillaryCharges",
    type: "null",
    hiddenType: "null",
    placeholder: "RpOrInAncCha",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a53d"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.NoShow",
    label: "No Show",
    type: "null",
    hiddenType: "null",
    placeholder: "noshow",
    needsReview: true,
    __v: 0,
    defid: "634ec3bbf0b07d199822a719"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a53e"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.CancelAttemptTooLate",
    label: "Cancel Attempt Too Late",
    type: "null",
    hiddenType: "null",
    placeholder: "canceltoolate",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed2c"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a53f"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.Refundable",
    label: "Refundable",
    type: "null",
    hiddenType: "null",
    placeholder: "refundable",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed58"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a540"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.Phone",
    label: "Customer Phone Number",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "customerphone",
    needsReview: true,
    __v: 0,
    defid: "675ccc16edc6d2c5a90ada3b"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a541"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.OrderAmount",
    label: "OrderAmount",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "RpOrInOrAmt",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a542"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.Currency",
    label: "Order Currency",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "RpOrInCur",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a543"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.MarketingSource",
    label: "MarketingSource",
    type: "null",
    hiddenType: "null",
    placeholder: "RpOrInMarSrc",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a544"
    },
    origin: "Representment",
    parent: "rp.OrderInfo",
    path: "rp.OrderInfo.SubMarketingSource",
    label: "SubMarketingSource",
    type: "null",
    hiddenType: "null",
    placeholder: "RpOrInSubMarSrc",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a545"
    },
    origin: "Representment",
    parent: "rp",
    path: "rp.Documents",
    label: "Documents",
    description: "This is an array in the API, but what goes in here?",
    type: "array",
    hiddenType: "array",
    placeholder: "RpDocs",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a546"
    },
    origin: "Representment",
    parent: "rp",
    path: "rp.AdditionalTransactions",
    label: "AdditionalTransactions",
    description: "This is an array in the API, containing zero or more instances of the object described here",
    type: "array",
    hiddenType: "array",
    placeholder: "RpAddtTra",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a547"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions",
    path: "rp.AdditionalTransactions{Object}",
    label: "{Object}",
    type: "object",
    hiddenType: "object",
    placeholder: "RpAddtTra",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a548"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}",
    path: "rp.AdditionalTransactions{Object}.Id",
    label: "Id",
    type: "number",
    hiddenType: "number",
    placeholder: "RpAddtTraId",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a549"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}",
    path: "rp.AdditionalTransactions{Object}.Transaction_Id",
    label: "Transaction_Id",
    type: "number",
    hiddenType: "number",
    placeholder: "RpAddtTraTrxId",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a54a"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}",
    path: "rp.AdditionalTransactions{Object}.TimeOfCharge",
    label: "TimeOfCharge",
    type: "string",
    hiddenType: "date",
    placeholder: "RpAddtTraTimOfCha",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a54b"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}",
    path: "rp.AdditionalTransactions{Object}.Amount",
    label: "Amount",
    type: "number",
    hiddenType: "number",
    placeholder: "RpAddtTraAmt",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a54c"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails",
    label: "TransactionDetails",
    description: "This is an object containing many data elements inside it",
    type: "object",
    hiddenType: "object",
    placeholder: "RpAddtTraTrxDet",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a54d"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.id",
    label: "id",
    type: "number",
    hiddenType: "number",
    placeholder: "RpAddtTra",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a54e"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.TransactionId",
    label: "TransactionId",
    type: "string",
    hiddenType: "number",
    placeholder: "RpAddtTraTrxId",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a54f"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.Amount",
    label: "Amount",
    type: "number",
    hiddenType: "number",
    placeholder: "RpAddtTraAmt",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a550"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.TransactionDate",
    label: "TransactionDate",
    type: "string",
    hiddenType: "date",
    placeholder: "RpAddtTraTrxDt",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a551"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.ActionType",
    label: "ActionType",
    type: "string",
    hiddenType: "string",
    placeholder: "RpAddtTraActTyp",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a552"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.MerchantAccount",
    label: "MerchantAccount",
    type: "string",
    hiddenType: "date",
    placeholder: "RpAddtTraMerAcn",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a553"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.ExternalTransactionId",
    label: "ExternalTransactionId",
    type: "string",
    hiddenType: "number",
    placeholder: "RpAddtTraExtTrxId",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a554"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.OriginalTransactionId",
    label: "OriginalTransactionId",
    type: "null",
    hiddenType: "null",
    placeholder: "RpAddtTraOriTrxId",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a555"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.RefundTransactions",
    label: "RefundTransactions",
    type: "null",
    hiddenType: "null",
    placeholder: "RpAddtTraRfndTra",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a556"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.ConsumerName",
    label: "ConsumerName",
    type: "string",
    hiddenType: "string",
    placeholder: "RpAddtTraCsmrNm",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a557"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.CompanyName",
    label: "CompanyName",
    type: "string",
    hiddenType: "string",
    placeholder: "RpAddtTraComNm",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a558"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.BIN",
    label: "BIN",
    type: "string",
    hiddenType: "number",
    placeholder: "RpAddtTra",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a559"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.LastFour",
    label: "LastFour",
    type: "string",
    hiddenType: "number",
    placeholder: "RpAddtTraLasFou",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a55a"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.CardBrand",
    label: "CardBrand",
    type: "string",
    hiddenType: "string",
    placeholder: "RpAddtTraCarBra",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a55b"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.Issuer",
    label: "Issuer",
    type: "string",
    hiddenType: "string",
    placeholder: "RpAddtTraIss",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a55c"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.CardTypeFromBIN",
    label: "CardTypeFromBIN",
    type: "string",
    hiddenType: "string",
    placeholder: "RpAddtTraCarTypFro",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a55d"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.Category",
    label: "Category",
    type: "string",
    hiddenType: "string",
    placeholder: "RpAddtTraCat",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a55e"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.Country",
    label: "Country",
    type: "string",
    hiddenType: "string",
    placeholder: "RpAddtTraCou",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a55f"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.CountryISO",
    label: "CountryISO",
    type: "string",
    hiddenType: "string",
    placeholder: "RpAddtTraCou",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a560"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.Sequence",
    label: "Sequence",
    type: "null",
    hiddenType: "null",
    placeholder: "RpAddtTraSeq",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a561"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.Retry",
    label: "Retry",
    type: "null",
    hiddenType: "null",
    placeholder: "RpAddtTraRet",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a562"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.Product",
    label: "Product",
    type: "null",
    hiddenType: "null",
    placeholder: "RpAddtTraPro",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a563"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.MerchantReference",
    label: "MerchantReference",
    type: "null",
    hiddenType: "null",
    placeholder: "RpAddtTraMerRef",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a564"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.TransactionType",
    label: "TransactionType",
    type: "string",
    hiddenType: "string",
    placeholder: "RpAddtTraTrxTyp",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a565"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.Success",
    label: "Success",
    type: "boolean",
    hiddenType: "boolean",
    placeholder: "RpAddtTraSuc",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a566"
    },
    origin: "Representment",
    path: "rp.AdditionalTransactions.0.TransactionDetails.FirstName",
    label: "FirstName",
    type: "null",
    hiddenType: "null",
    placeholder: "RpAddtTraFirNm",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a567"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.LastName",
    label: "LastName",
    type: "null",
    hiddenType: "null",
    placeholder: "RpAddtTraLasNm",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a568"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.Selected",
    label: "Selected",
    type: "boolean",
    hiddenType: "boolean",
    placeholder: "RpAddtTraSel",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a569"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.AuthorizationCode",
    label: "AuthorizationCode",
    type: "string",
    hiddenType: "number",
    placeholder: "RpAddtTraAutCod",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a56a"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.ARN",
    label: "ARN",
    type: "null",
    hiddenType: "null",
    placeholder: "RpAddtTra",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a56b"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.Source",
    label: "Source",
    type: "null",
    hiddenType: "null",
    placeholder: "RpAddtTraSrc",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a56c"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.HasAChargeback",
    label: "HasAChargeback",
    type: "boolean",
    hiddenType: "boolean",
    placeholder: "RpAddtTraHasCB",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a56d"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.MeetsCE3Criteria",
    label: "MeetsCE3Criteria",
    type: "null",
    hiddenType: "null",
    placeholder: "RpAddtTraMeeCri",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a56e"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.ChargebackReasonCode",
    label: "ChargebackReasonCode",
    type: "string",
    hiddenType: "number",
    placeholder: "RpAddtTraCBReaCod",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a56f"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.ChargebackReasonCodeDescription",
    label: "ChargebackReasonCodeDescription",
    type: "string",
    hiddenType: "string",
    placeholder: "RpAddtTraCBReaCodDesc",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a570"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.ChargebackReasonCodeCategory",
    label: "ChargebackReasonCodeCategory",
    type: "string",
    hiddenType: "string",
    placeholder: "RpAddtTraCBReaCodCat",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a571"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.IPAddress",
    label: "IPAddress",
    type: "string",
    hiddenType: "string",
    placeholder: "RpAddtTraAdr",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a572"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.DeviceId",
    label: "DeviceId",
    type: "null",
    hiddenType: "null",
    placeholder: "RpAddtTraDevId",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a573"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.CRMUserName",
    label: "CRMUserName",
    type: "null",
    hiddenType: "null",
    placeholder: "RpAddtTraUsrNm",
    needsReview: true,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a574"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.ShipToDifferent",
    label: "ShipToDifferent",
    type: "boolean",
    hiddenType: "boolean",
    placeholder: "RpAddtTraShiToDif",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a575"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.AVSCode",
    label: "AVSCode",
    type: "string",
    hiddenType: "string",
    placeholder: "RpAddtTraCod",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a576"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.AVSCodeDescription",
    label: "AVSCodeDescription",
    type: "string",
    hiddenType: "string",
    placeholder: "RpAddtTraCodDesc",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a577"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.CVSMatchCode_Id",
    label: "CVSMatchCode_Id",
    type: "number",
    hiddenType: "number",
    placeholder: "RpAddtTraMatCodId",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a578"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.Descriptor",
    label: "Descriptor",
    type: "string",
    hiddenType: "string",
    placeholder: "RpAddtTraDes",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a579"
    },
    origin: "Representment",
    parent: "rp.AdditionalTransactions{Object}.TransactionDetails",
    path: "rp.AdditionalTransactions{Object}.TransactionDetails.SettlementDate",
    label: "SettlementDate",
    type: "string",
    hiddenType: "date",
    placeholder: "RpAddtTraSetDt",
    needsReview: false,
    __v: 0
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a57a"
    },
    origin: "Representment",
    parent: "rp",
    path: "rp.DaysBetweenCancellationAndCB",
    label: "Days Between Cancellation and Chargeback",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "daysbetweencancellationandcb",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed75"
  },
  {
    _id: {
      $oid: "678d28d664348d2a78e5a57b"
    },
    origin: "Representment",
    parent: "rp",
    path: "rp.DaysBetweenRefundAndCB",
    label: "Days Between Refund and Chargeback",
    useInContent: true,
    type: "null",
    hiddenType: "null",
    placeholder: "daysbetweenrefundandcb",
    needsReview: true,
    __v: 0,
    defid: "62980feeab36c31cc0a9ed76"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c16349e"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.Id",
    label: "Merchant Id",
    useInContent: true,
    description: "Id of the merchant account.",
    type: "number",
    hiddenType: "number",
    placeholder: "merchantid",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed4e"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c16349f"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.MerchantAccountId",
    label: "Merchant Account Id",
    useInContent: true,
    description: "Id of the merchant account.",
    type: "number",
    hiddenType: "number",
    placeholder: "merchantaccountid",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed42"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634a0"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.Name",
    label: "Merchant Name",
    useInContent: true,
    description: "Merchant Name.",
    type: "string",
    hiddenType: "string",
    placeholder: "merchantname",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed4f"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634a1"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.ProcessorName",
    label: "Merchant Processor Name",
    useInContent: true,
    description: "Merchant Processor Name.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchProcessorId",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634a2"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.ProcessorUrl",
    label: "Merchant Processor Url",
    useInContent: true,
    description: "Merchant Processor Url.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchProcessorUrl",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634a3"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.ProcessorFaxOther",
    label: "Merchant Processor Fax Other",
    description: "Merchant Processor Fax Other.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchProcessorFaxOther",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634a4"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.Address",
    label: "Merchant Address",
    useInContent: true,
    description: "Address of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "merchantaddress",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed41"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634a5"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.Email",
    label: "Merchant Email",
    useInContent: true,
    description: "Email of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "merchantemail",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed48"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634a6"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.City",
    label: "Merchant City",
    useInContent: true,
    description: "City of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "merchantcity",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed46"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634a7"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.State",
    label: "Merchant State",
    useInContent: true,
    description: "State of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "merchantstate",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed51"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634a8"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.Zip",
    label: "Merchant Zip Code",
    useInContent: true,
    description: "Zip code of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "merchantzip",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed52"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634a9"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.ProcessorFax",
    label: "Merchant Processor Fax ",
    description: "Merchant Processor Fax .",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchProcessorFax",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634aa"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.Processor",
    label: "Merchant Processor Object ",
    description: "Merchant Processor Object .",
    type: "object",
    hiddenType: "object",
    placeholder: "MerchProcessorObj",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634ab"
    },
    origin: "Merchant",
    parent: "merchant.Processor",
    path: "merchant.Processor.Id",
    label: "Processor Id",
    description: "Merchant Processor Object Id .",
    type: "number",
    hiddenType: "number",
    placeholder: "processor_id",
    needsReview: false,
    defid: "62ab5665e4fe131f900531a2"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634ac"
    },
    origin: "Merchant",
    parent: "merchant.Processor",
    path: "merchant.Processor.Name",
    label: "Processor Name",
    description: "Merchant Processor Object Name .",
    type: "number",
    hiddenType: "number",
    placeholder: "processor",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed56"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634ad"
    },
    origin: "Merchant",
    parent: "merchant.Processor",
    path: "merchant.Processor.Url",
    label: "Merchant Processor Obj Url ",
    description: "Merchant Processor Object Url .",
    type: "number",
    hiddenType: "number",
    placeholder: "MerchProcessorObjUrl",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634ae"
    },
    origin: "Merchant",
    parent: "merchant.Processor",
    path: "merchant.Processor.Email",
    label: "Merchant Email",
    description: "Merchant Processor Obj Email.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchEmail",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634af"
    },
    origin: "Merchant",
    parent: "merchant.Processor",
    path: "merchant.Processor.Fax",
    label: "Merchant Fax",
    description: "Merchant Processor Obj Fax.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchFax",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634b0"
    },
    origin: "Merchant",
    parent: "merchant.Processor",
    path: "merchant.Processor.Notes",
    label: "Merchant Notes",
    description: "Merchant Processor Obj Notes.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchNotes",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634b1"
    },
    origin: "Merchant",
    parent: "merchant.Processor",
    path: "merchant.Processor.Address",
    label: "Merchant Address",
    description: "Merchant Processor Obj Address.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchAddress",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634b2"
    },
    origin: "Merchant",
    parent: "merchant.Processor",
    path: "merchant.Processor.City",
    label: "Merchant City",
    description: "Merchant Processor Obj City.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchCity",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634b3"
    },
    origin: "Merchant",
    parent: "merchant.Processor",
    path: "merchant.Processor.State",
    label: "Merchant State",
    description: "Merchant Processor Obj State.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchState",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634b4"
    },
    origin: "Merchant",
    parent: "merchant.Processor",
    path: "merchant.Processor.Zip",
    label: "Merchant Zip",
    description: "Merchant Processor Obj Zip.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchZip",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634b5"
    },
    origin: "Merchant",
    parent: "merchant.Processor",
    path: "merchant.Processor.RepresentmentEmail",
    label: "Merchant RepresentmentEmail",
    description: "Merchant Processor Obj RepresentmentEmail.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchRepresentmentEmail",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634b6"
    },
    origin: "Merchant",
    parent: "merchant.Processor",
    path: "merchant.Processor.RepresentmentFax",
    label: "Merchant RepresentmentFax",
    description: "Merchant Processor Obj RepresentmentFax.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchRepresentmentFax",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634b7"
    },
    origin: "Merchant",
    parent: "merchant.Processor",
    path: "merchant.Processor.RepresentmentPhone",
    label: "Merchant RepresentmentPhone",
    description: "Merchant Processor Obj RepresentmentPhone.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchRepresentmentPhone",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634b8"
    },
    origin: "Merchant",
    parent: "merchant.Processor",
    path: "merchant.Processor.SubmissionType",
    label: "Merchant SubmissionType",
    description: "Merchant Processor Obj SubmissionType.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchSubmissionType",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634b9"
    },
    origin: "Merchant",
    parent: "merchant.Processor",
    path: "merchant.Processor.SftpHostName",
    label: "Merchant SftpHostName",
    description: "Merchant Processor Obj SftpHostName.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchSftpHostName",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634ba"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.Processor.SftpUserName",
    label: "Merchant SftpUserName",
    description: "Merchant Processor Obj SftpUserName.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchSftpUserName",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634bb"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.Processor.SftpPassword",
    label: "Merchant SftpPassword",
    description: "Merchant Processor Obj SftpPassword.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchSftpPassword",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634bc"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.Processor.SftpDirectory",
    label: "Merchant SftpDirectory",
    description: "Merchant Processor Obj SftpDirectory.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchSftpDirectory",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634bd"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.Processor.TechnologyType",
    label: "Merchant ChargebackSource Id",
    description: "Merchant Processor Chargeback Source Id.",
    type: "number",
    hiddenType: "number",
    placeholder: "MerchChargebackSourceId",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634be"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.Processor.TechnologyType",
    label: "Merchant Technology Type",
    description: "Merchant Processor Technology Type.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchTechnologyType",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634bf"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.Contact",
    useInContent: true,
    label: "Merchant Contact",
    description: "Merchant Contact",
    type: "string",
    hiddenType: "string",
    placeholder: "merchantcontact",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed47"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634c2"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.Phone",
    label: "Merchant Phone",
    useInContent: true,
    description: "Phone of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "merchantphone",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed50"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634c6"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.DBA",
    label: "Merchant DBA",
    useInContent: true,
    description: "DBA of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "dba",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed4d"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634c7"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.Company",
    label: "Merchant Company",
    useInContent: true,
    description: "Company of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "company",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed74"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634c8"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.ChargeType_Id",
    label: "Charge Type ID",
    useInContent: true,
    description: "ChargeType_Id of the merchant account.",
    type: "number",
    hiddenType: "number",
    placeholder: "chargetypeid",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed35"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634c9"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.DeliveryType_Id",
    label: "Merchant Delivery Type",
    useInContent: true,
    description: "DeliveryType_Id of the merchant account.",
    type: "number",
    hiddenType: "number",
    placeholder: "merchantdeliverytype",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed4c"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634ca"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.ProductType_Id",
    label: "Product Type Id",
    useInContent: true,
    description: "ProductType_Id of the merchant account.",
    type: "number",
    hiddenType: "number",
    placeholder: "producttype",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed55"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634cb"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.AcceptedCardTypes",
    label: "Merchant AcceptedCardTypes",
    description: "AcceptedCardTypes of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchAcceptedCardTypes",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634cc"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.Descriptor1",
    label: "Merchant Descriptor 1",
    useInContent: true,
    description: "Descriptor1 of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "merchantdescrip1",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed49"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634cd"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.Descriptor2",
    label: "Merchant Descriptor 2",
    useInContent: true,
    description: "Descriptor2 of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "merchantdescrip2",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed4a"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634ce"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.MCC",
    label: "Merchant MCC",
    description: "MCC of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchMCC",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634cf"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.CustomerServicePhone",
    label: "Customer Service Phone",
    useInContent: true,
    description: "CustomerServicePhone of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "customerservicephone",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed37"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634d0"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.WebsiteUrl",
    label: "Website URL",
    useInContent: true,
    description: "WebsiteUrl of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "weburl",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed72"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634d1"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.SupportEmail",
    label: "Support Email",
    useInContent: true,
    description: "Support Email of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "supportemail",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed67"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634d2"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.SupportChat",
    label: "Merchant SupportChat",
    description: "Support Chat of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchSupportChat",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634d3"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.SupportPhone",
    label: "Support Phone",
    useInContent: true,
    description: "Support Phone of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "supportphone",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed68"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634d4"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.TermsUrl",
    label: "Terms URL",
    useInContent: true,
    description: "Terms Url of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "termsurl",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed6b"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634d5"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.TermsText",
    label: "Terms Text",
    useInContent: true,
    description: "Terms Text of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "terms",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed69"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634d6"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.RefundPolicyUrl",
    label: "Refund Policy URL",
    useInContent: true,
    description: "Refund Policy Url of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "refundpolicyurl",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed5a"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634d7"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.RefundPolicyText",
    label: "Refund Policy Text",
    useInContent: true,
    description: "Refund Policy Text of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "refundpolicy",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed60"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634d8"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.ReturnPolicyUrl",
    label: "Return Policy URL",
    useInContent: true,
    description: "Return Policy Url of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "returnpolicyurl",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed5d"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634d9"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.ReturnPolicy",
    label: "Return Policy Text",
    useInContent: true,
    description: "Return Policy of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "returnpolicy",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed5f"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634da"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.ReturnPolicyDays",
    label: "Merchant ReturnPolicyDays",
    useInContent: true,
    description: "Return Policy Days of the merchant account. Is this a number or string?",
    type: "number",
    hiddenType: "number",
    placeholder: "MerchReturnPolicyDays",
    needsReview: true
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634db"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.ContactUrl",
    label: "Merchant ContactUrl",
    useInContent: true,
    description: "Contact Url Text of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchContactUrl",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634dc"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.CancellationPolicyText",
    label: "Cancellation Policy Text",
    useInContent: true,
    description: "Cancellation Policy Text of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "cancelpolicy",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed33"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634dd"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.AccountClassification",
    label: "Business Category",
    useInContent: true,
    description: "Account Classification of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "businesscategory",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed28"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634de"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.BusinessDescription",
    label: "Business Description",
    useInContent: true,
    description: "Business Description of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "businessdescrip",
    needsReview: false,
    defid: "62980feeab36c31cc0a9ed29"
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634df"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.StoreName",
    label: "Merchant StoreName",
    useInContent: true,
    description: "Store name of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchStoreName",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634e0"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.CorporateMerchantName",
    label: "Merchant CorporateMerchantName",
    useInContent: true,
    description: "Corporate MerchantName name of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchCorpName",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634e1"
    },
    origin: "Merchant",
    path: "merchant.Processor.ProcessorReplyByDays",
    label: "Merchant Processor Reply By Days Array",
    description: "Array of Reply-By-Days objects.",
    type: "array",
    hiddenType: "array",
    placeholder: "MerchProcessorReplyByDays",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634e2"
    },
    origin: "Merchant",
    parent: "merchant.Processor.ProcessorReplyByDays",
    path: "merchant.Processor.ProcessorReplyByDays{Object}",
    label: "{Object}",
    description: "There can be multiple instances of this object in Merchant Processor Reply By Days array.",
    type: "object",
    hiddenType: "object",
    placeholder: "MerchProcessorReplyByDaysObj",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634e3"
    },
    origin: "Merchant",
    parent: "merchant.Processor.ProcessorReplyByDays{Object}",
    path: "merchant.Processor.ProcessorReplyByDays{Object}.Id",
    label: "Id",
    description: "Id of the reply by days object.",
    type: "number",
    hiddenType: "number",
    placeholder: "MerchProcessorReplyByDaysObjId",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634e4"
    },
    origin: "Merchant",
    parent: "merchant.Processor.ProcessorReplyByDays{Object}",
    path: "merchant.Processor.ProcessorReplyByDays{Object}.Cycle",
    label: "Cycle",
    description: "Cycle of the reply by days object.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchProcessorReplyByDaysObjCycle",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634e5"
    },
    origin: "Merchant",
    parent: "merchant.Processor.ProcessorReplyByDays{Object}",
    path: "merchant.Processor.ProcessorReplyByDays{Object}.CardBrand",
    label: "CardBrand",
    description: "Card Brand of the reply by days object.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchProcessorReplyByDaysObjCardBrand",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634e6"
    },
    origin: "Merchant",
    parent: "merchant.Processor.ProcessorReplyByDays{Object}",
    path: "merchant.Processor.ProcessorReplyByDays{Object}.ReplyByDays",
    label: "ReplyByDays",
    description: "ReplyByDays of the reply by days object.",
    type: "number",
    hiddenType: "number",
    placeholder: "MerchProcessorReplyByDaysObjRBD",
    needsReview: false
  },
  {
    _id: {
      $oid: "67b4782c59eee30a1c1634e7"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.CancelRefundPolicyDisclosure",
    label: "Merchant CancelRefundPolicyDisclosure",
    useInContent: true,
    description: "Cancel RefundPolicy Disclosure of the merchant account.",
    type: "string",
    hiddenType: "string",
    placeholder: "MerchCancelRefundPolicyDisc",
    needsReview: false
  },
  {
    _id: {
      $oid: "67bed7e859eee30a1c16350e"
    },
    origin: "Merchant",
    parent: "merch",
    path: "merchant.AccountNumber",
    label: "Merchant Acct Number",
    useInContent: true,
    description: "Account # of the merchant.",
    type: "number",
    hiddenType: "number",
    placeholder: "MerchAcct",
    needsReview: false
  }
]